import O1HD, { managers, modules, services } from "../engines/gameEngine";
import { oneSonLoadProgress, RESOURCES_TYPE } from "./loading/loadConfig_json";
import { GameModeDetail } from "../engines/managers/gameManager";
import gameConfig from "../engines/configs/gameConfig";
import logScreen from "../O1ModuleRes/frame/logScreen";
import realNameATT from "./start/realNameATT";
import CsvDataManage from "../engines/managers/CsvDataManage";
import TtApi from "../engines/services/miniGameContent/tt/ttApi";
import { PLATFORM_CODE } from "../engines/services/ossService";
import { xj_sdk } from "../engines/services/miniGameContent/tt/xj.sdk";

let { ccclass, property } = cc._decorator;

@ccclass
export default class loading extends cc.Component {

    @property({ displayName: '预加载场景', tooltip: '是否预先加载大厅和游戏场景' })
    pmPreLoadScenes = true;

    @property({ type: cc.ProgressBar, displayName: '进度条' })
    pmLoadBar: cc.ProgressBar = null;

    @property({ type: cc.ProgressBar, displayName: '子进度条' })
    pmSonLoadBar: cc.ProgressBar = null;

    @property({ displayName: '是否显示子进度条' })
    isShowSonBar: boolean = true;

    @property({ displayName: '子进度条加载条数' })
    sonLoadCount: number = 100;

    @property({ type: cc.Label, displayName: '进度文字' })
    pmLoadLabel: cc.Label = null;

    // @property({ type: cc.Node, displayName: '实名认证节点' })
    // ndRealNameAtt: cc.Node = null;

    @property(cc.Node)
    nodePatents: cc.Node = null;

    @property(cc.Node)
    nodeAgeTag: cc.Node = null;


    protected start() {
        // this.ndRealNameAtt.active = false;
        this.nodePatents.active = false;
        this.nodeAgeTag.active = false;
    }

    onLoad() {
        // let canvas:cc.Canvas = this.node.getComponent(cc.Canvas);
        // console.log("变更适配");
        // if(canvas){
        //     canvas.fitHeight = true;
        //     canvas.fitWidth = true;
        // }
        O1HD.on('loading-title', (str: string) => {
            this.pmLoadLabel.string = str;
        }, this);

        if (gameConfig.IS_OPEN_CLOG) {
            console.log('<loading> 场景');
        }
        //
        this.pmLoadBar.progress = 0;
        this.pmLoadLabel.string = `正在初始化`;
        this.pmSonLoadBar.progress = 0;
        this.pmSonLoadBar.node.active = this.isShowSonBar;
        //
        this.loadPackages();
    }

    loadPackages() {
        //
        this.loadSubpackages().then(() => {

            let platform:PLATFORM_CODE = O1HD.getServices().ossSrv.getPlatform();
            switch(platform){
                case PLATFORM_CODE.TT:{
                    console.log('tt xj_sdk init');
                    xj_sdk.init({
                        success: () => {
                            console.log("xj_sdk init success")
                        },
                        fail: () => {
                            console.log("xj_sdk init fail")
                        }
                    })   
                    break;
                }
            }
            //
            let mainSceneName = managers().gameMgr.getMainSceneNameAndLoadBundle();
            if (typeof mainSceneName === 'string') {
                this.preLoadSceneOver(mainSceneName);
            } else {
                if (gameConfig.IS_OPEN_CLOG) {
                    console.info("loadPackages two", mainSceneName)
                }
                O1HD.getManagers().gameMgr.onGameRun();
                O1HD.getServices()
                    && O1HD.getServices().miniGameSrv.getAppApiInstance
                    && O1HD.getServices().miniGameSrv.getAppApiInstance().screenFit();
                managers().gameMgr.selectMode(mainSceneName.type).then();
                // this.preLoadSceneOver(mainSceneName.sceneName);
                this.loginEcpm()
            }
        });
    }

    private m_allPreloadResources: oneSonLoadProgress[] = [];

    async onAddLogServiceNode(): Promise<void> {
        return new Promise(resolve => {
            if (gameConfig.LOG_SERVICE_OPEN &&
                gameConfig.SCREEN_LOG_SWITCH) {
                modules().uiControlModule.showFramePrefab('preload/frame/logScreen', O1HD.Canvas().parent, false, node => {
                    services().logSrv.addScreenPrint(node.getComponent(logScreen));
                    resolve();
                });
            } else {
                resolve();
            }
        });
    }

    async loadSubpackages() {
        //
        await O1HD.loadAll();

        let miniApp = O1HD.getServices().miniGameSrv.getAppApiInstance();
        this.nodeAgeTag.active = miniApp.isShowAgeTag();
        this.nodePatents.active = miniApp.isShowPatents();
        //
        await this.loadAllPreloadResources();
      
        await this.onAddLogServiceNode();

        O1HD.getManagers().gameMgr.loadChaoPiaoPrefab();
        return Promise.resolve();
    }

    //初始化要加载的数据
    initPreloadResources() {
        //配置
        this.m_allPreloadResources = [];
        //公用字体包
        this.m_allPreloadResources.push({
            resourcesType: RESOURCES_TYPE.BUNDLE,
            resPathOrName: modules().uiControlModule.getFontBundlePath(),
            loadText: '加载公用字体包',
            onBundleLoaded: bundle => {

            },
        });
        //框架包
        this.m_allPreloadResources.push({
            resourcesType: RESOURCES_TYPE.BUNDLE,
            resPathOrName: modules().uiControlModule.getFrameBundlePath(),
            loadText: '加载框架包',
            onBundleLoaded: bundle => {
                modules().uiControlModule.setFrameBundle(bundle);
            },
        });
        //框架资源
        this.m_allPreloadResources.push({
            resourcesType: RESOURCES_TYPE.ASSETS,
            resPathOrName: modules().uiControlModule.getFrameBundlePreloadResPath(),
            loadText: '加载框架资源',
            bundle: () => {
                return modules().uiControlModule.getFrameBundle();
            },
        });
        //游戏包
        this.m_allPreloadResources.push({
            resourcesType: RESOURCES_TYPE.BUNDLE,
            resPathOrName: modules().uiControlModule.getGameBundlePath(),
            loadText: '加载游戏公共包',
            onBundleLoaded: bundle => {
                modules().uiControlModule.setGameBundle(bundle);
            },
        });
        //游戏资源
        // this.m_allPreloadResources.push({
        //     resourcesType: RESOURCES_TYPE.ASSETS,
        //     resPathOrName: modules().uiControlModule.getGameBundlePreloadResPath(),
        //     loadText: '加载游戏资源',
        //     bundle: () => {
        //         return modules().uiControlModule.getGameBundle();
        //     },
        // });
        //hall分包
        // this.m_allPreloadResources.push({
        //     resourcesType: RESOURCES_TYPE.BUNDLE,
        //     resPathOrName: 'hall',
        //     loadText: '加载总场景包',
        // })
        //主场景资源
        let mainSceneBundle = managers().gameMgr.getMainSceneNameAndLoadBundle();
        if (null == mainSceneBundle) {
            console.error('#69 主场景配置错误');
        }
        //主场景 为 hall
        if (mainSceneBundle === 'hall') {
            this.m_allPreloadResources.push({
                resourcesType: RESOURCES_TYPE.SCENE,
                resPathOrName: mainSceneBundle,
                loadText: '加载主场景'
            })
            //否则就调用其他子包
        } else {
            let bundleInfo = <GameModeDetail>mainSceneBundle;
            let startMill = 0;
            if (gameConfig.IS_OPEN_CLOG) {
                startMill = new Date().getTime();
                console.log("子包加载时间", startMill);
            }
            //先加载子包
            this.m_allPreloadResources.push({
                resourcesType: RESOURCES_TYPE.BUNDLE,
                resPathOrName: bundleInfo.name,
                loadText: '加载主场景包',
                onBundleLoaded: (bundle) => {
                    bundleInfo.bundle = bundle;
                    managers().gameMgr.setMainModeLoaded(bundleInfo);
                    if (gameConfig.IS_OPEN_CLOG) {
                        let endBundleMill = new Date().getTime();
                        console.log("子包 bundle 加载完成时间", endBundleMill - startMill);
                    }
                }
            })
            //
            this.m_allPreloadResources.push({
                resourcesType: RESOURCES_TYPE.SCENE,
                resPathOrName: bundleInfo.sceneName,
                loadText: '加载主场景资源',
            });
            if (gameConfig.IS_OPEN_CLOG) {
                let endSceneMill = new Date().getTime();
                console.log("子包 Scene 加载完成时间", endSceneMill - startMill);
            }
        }
    }

    async loadAllPreloadResources(): Promise<void> {

        //
        this.initPreloadResources();
        //
        await this.startPreloadResources();
        //
        return Promise.resolve();
    }

    //开始加载数据
    async startPreloadResources(): Promise<void> {
        const { length } = this.m_allPreloadResources;

        let startMill = 0;
        let resTime = 0;
        if (gameConfig.IS_OPEN_CLOG) {
            resTime = startMill = new Date().getTime();
            console.log(`加载总资源数`, length, startMill);
        }
        for (let i = 0; i < length; i++) {
            let currLoad = this.m_allPreloadResources[i];

            // if ( currLoad.resPathOrName == "normalMode" ) {
            //     // this.preloadOneResources(currLoad, startProgress);
            //     continue;
            // }
            //
            let startProgress = i / length;
            this.setLoadProgress(startProgress, currLoad.loadText);
            //
            await this.preloadOneResources(currLoad, startProgress);
            if (gameConfig.IS_OPEN_CLOG) {
                let cTime = new Date().getTime();
                console.log(`加载 ${currLoad.resPathOrName}:${currLoad.loadText}`, (cTime - resTime)/1000);
                resTime = cTime;
            }
        }

        await CsvDataManage.instance.initCsvList();

        if (gameConfig.IS_OPEN_CLOG) {
            let endMill = new Date().getTime();
            console.log(`加载总资源时间`, endMill - startMill);
        }
        return Promise.resolve();
    }

    //加载一个
    async preloadOneResources(currLoad: oneSonLoadProgress, startProgress: number): Promise<void> {
        return new Promise(resolve => {
            const { resourcesType, resPathOrName, bundle, onBundleLoaded, onComplete } = currLoad;
            // let startMill = new Date().getTime();
            // console.log(`preloadOneResources:${resourcesType},${resPathOrName}`)
            //资源类型
            switch (resourcesType) {
                //分包
                case RESOURCES_TYPE.BUNDLE: {
                    cc.assetManager.loadBundle(resPathOrName, (err, bundle) => {
                        onBundleLoaded && onBundleLoaded(bundle);
                        // console.log(`preloadOneResources:${resourcesType},${resPathOrName}`,new Date().getTime() - startMill );
                        resolve();
                    });
                    break;
                }
                case RESOURCES_TYPE.ASSETS: {
                    bundle().loadDir(resPathOrName, (finish, total) => {
                        this.setSonLoadProgress(finish / total, startProgress);
                    }, (error, assets) => {
                        // console.log(`preloadOneResources:${resourcesType},${resPathOrName}`,new Date().getTime() - startMill );
                        onComplete && onComplete(error, assets);
                        resolve();
                    })
                    break;
                }
                case RESOURCES_TYPE.SCENE: {
                    cc.director.preloadScene(resPathOrName, (completedCount, totalCount) => {
                        this.setSonLoadProgress(completedCount / totalCount, startProgress);
                    }, error => {
                        // console.log(`preloadOneResources:${resourcesType},${resPathOrName}`,new Date().getTime() - startMill );
                        resolve();
                    })
                    break;
                }
            }

        })
    }

    preLoadSceneOver(mainSceneName: string) {
        this.setLoadProgress(1, '游戏加载完成');
        // this.ndRealNameAtt.active = true;

        // this.ndRealNameAtt.getComponent(realNameATT).onRealName().then(() => {
        //     //
        //     this.loginEcpm()
        //     O1HD.loadScene(mainSceneName, () => {
        //         O1HD.getManagers().gameMgr.onGameRun();
        //         O1HD.getServices()
        //             && O1HD.getServices().miniGameSrv.getAppApiInstance
        //             && O1HD.getServices().miniGameSrv.getAppApiInstance().screenFit();
        //     });

        // })
    }


    async loginEcpm() {
        if (services().ossSrv.getPlatform() != "tt") return
        let ttCode: string = "";
        let ttAnonyCode: string = "";
        let ttUserName: string = "";
        let ttIcon: string = "";
        let ttProvince: string = "";
        let clickId: string = "";
        if (cc.sys.platform == cc.sys.BYTEDANCE_GAME || cc.sys.platform == cc.sys.BYTEDANCE_GAME_SUB) {
            const tt = window["tt"];
            const launchOpt = tt.getLaunchOptionsSync();
            // console.log("启动参数====>",launchOpt.query);
            clickId = JSON.stringify(launchOpt.query);
            await new Promise<void>((resolve) => {
                let sv = <TtApi>services().miniGameSrv.getAppApiInstance();
                sv.login({
                    success: (data) => {
                        console.info("抖音登录成功！！！", JSON.stringify(data))
                        ttCode = data.code;
                        ttAnonyCode = data.anonymousCode;
                        // resolve();
                        sv.getUserInfo({
                            success: (uinfo) => {
                                console.info("抖音请求用户数据成功！！！", JSON.stringify(uinfo))
                                ttUserName = uinfo.userInfo.nickName;
                                ttIcon = uinfo.userInfo.avatarUrl;
                                ttProvince = uinfo.userInfo.province;
                                resolve();
                            },
                            fail: () => {
                                resolve();
                            }
                        })
                    },
                    fail: () => {
                        console.info("抖音登录失败！！！")
                        resolve();
                    }
                })
            })
        }
        services().userSrv.getPlayerHttpAccount(ttCode, ttAnonyCode, ttUserName, ttIcon, ttProvince, clickId);

    }
    private setSonLoadProgress(progress: number, startProgress: number) {
        this.pmSonLoadBar.progress = progress;
        const length = this.m_allPreloadResources.length;
        this.setLoadProgress(startProgress + progress / length);
    }

    private setLoadProgress(progress: number, text?: string) {
        this.pmLoadBar.progress = progress;
        if (text) {
            this.pmLoadLabel.string = `${text}(${(progress * 100).toFixed(1)}%)`;
        }
    }
}

